import React from "react";
import { useTranslation } from "react-i18next";
import EACheckbox from "../../shared/Checkbox/EACheckbox";
import { Controller } from "react-hook-form";
import CheckBoxNewsletter from "../inputsForm/CheckBoxNewsletter";
import "./ConsentInputs.scss";
import { useSelector } from "react-redux";
import { State } from "../../../store";
import OtherConsentCheckboxes from "./OtherConsentCheckboxes";
import EALink from "../../shared/Link/EALink";
import useFacility from "../../../../utils/hooks/useFacility";
import CheckBoxNewsletterKRK from "../inputsForm/CheckBoxNewsletterKRK";

interface IProps {
  errors: any;
  control: any;
  setValue: any;
  email?: string;
  title?: string;
  newsletter?: boolean;
}

const ConsentInputs: React.FC<IProps> = ({ errors, control, setValue, email = "", title = "", newsletter }) => {
  const configuration = useSelector((state: State) => state.config.configuration);
  const { t } = useTranslation();
  const regulaminList = useSelector((state: State) => state.config.configuration?.regulaminList) || [];
  const newsletterActive = useSelector((state: State) => state.config.configuration?.newsLetterActive);
  const userNewsletterAccepted = useSelector((state: State) => state.auth.userData.allowMailing);
  const facilityIds = useFacility();
  const isB2B = Boolean(useSelector((state: State) => state.auth.userData.b2bType));

  const getStoreTermsText = () => {
    const storeTerms = regulaminList?.find((item) => item?.type === "StoreTerms");
    if (storeTerms?.active && storeTerms?.file) {
      return (
        <>
          {" "}
          {t("oraz")}{" "}
          <a target="_blank" rel="noreferrer" href={storeTerms.file}>
            {t("regulamin")} {t("sprzedaży")}
          </a>
        </>
      );
    }
    return "";
  };

  return (
    <div className="consent-inputs__container">
      {title && <h3>{title}</h3>}

      <Controller
        name="acceptEAktywni"
        control={control}
        rules={{ required: true }}
        render={({ field }) => (
          <EACheckbox
            name="acceptEAktywni"
            field={field}
            errors={errors}
            label={
              <span>
                *{t("akceptuje")} {""}
                <a target="_blank" rel="noreferrer" href={"https://eaktywni.pl/regulamin/"}>
                  {t("regulamin")} {t("serwisu")} eAktywni.pl
                </a>
                {getStoreTermsText()}
              </span>
            }
          />
        )}
      />

      <OtherConsentCheckboxes errors={errors} control={control} setValue={setValue} />

      <span className="body-text-small">
        {t(
          "Dane osobowe zbieramy na potrzeby realizacji i zakupu biletów, więcej o tym jak przetwarzamy dane osobowe dowiesz się tutaj:"
        )}{" "}
        {configuration.regulaminList[0] && (
          <EALink to={configuration.regulaminList[0].file} title={t("polityka_prywatnosci")} />
        )}
        {newsletter && (
          <>
            {newsletterActive && !userNewsletterAccepted && !isB2B && (
              <>
                {facilityIds === "1241" || facilityIds === "1243" ? (
                  <CheckBoxNewsletterKRK
                    email={email}
                    onAllowMailingChange={(value) => setValue("allowMailing", value)}
                  />
                ) : (
                  <CheckBoxNewsletter email={email} onAllowMailingChange={(value) => setValue("allowMailing", value)} />
                )}
              </>
            )}
          </>
        )}
      </span>
    </div>
  );
};

export default ConsentInputs;
